export default {
      id: "caret-right-usage",
      viewBox: "0 0 192 512",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#caret-right",
      toString: function () {
        return this.url;
      }
    }